export const NEWSLETTER: string = 'newsletter';
export const NEWSLETTER_CONSENT: string = 'Yes, I want to subscribe'; // more items will be added later to subscriptions



// WEBPACK FOOTER //
// ./src/constants/subscriptions.ts